// Backend URL for the whole website. Change it here if the backend moves.
export const GLOBAL_BACKEND_URL = "https://chillaos-backend.onrender.com/api";
